import { makeAutoObservable } from 'mobx'

/**
 * @class MeetingStore
 * @description This class represents the store for meetings. It manages the state of meetings and is part of the root store.
 */
class MeetingStore {
	/**
	 * @property {Object} meetings - An object containing meetings indexed by their IDs.
	 */
	meetings = {}

	/**
	 * @constructor
	 * @param {Object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of MeetingStore and makes it observable.
	 */
	constructor(rootStore) {
		this.rootStore = rootStore
		makeAutoObservable(this)
	}
}

export default MeetingStore
